// SETUP AXIOS HEADERS
const headers = {
  'Ocp-Apim-Subscription-Key': 'f718d6d8af9848008b8f6a6f516cb7ba', // QA
  'app-type': 'va',
  'Content-Type': 'application/json',
}

export { headers }
